<template>
 <div style="width: 100%; height: 100%;">
   <div id="data-view">
     <div class="data">
       <div class="data-title">
         <top/>
         <dv-decoration-10 style="width:98%;height:5px;margin-left: 1%"/>
       </div>
       <div class="data-content">
         <div class="data-content-left">
           <left @callBackInfo="getTypeIndex"  ref="left"/>
         </div>
<!--         <div class="data-content-right" style="background-color: rgba(6, 30, 93, 0.2)">-->

<!--         </div>-->

<!--         v-if  或者  v-show-->
         <div class="data-content-right">
           <main-screen ref="mainScreen" @soilMeteCount="getSoilMete" @sporeCount="getSporeCount"  @insectCount="getInsectCount" v-if="indexType == 1 ? true : false"/>

           <mete-real-data ref="meteRealData" v-if="indexType == 2 ? true : false"/>
           <mete-history-data ref="meteHistoryData" v-if="indexType == 3 ? true : false"/>

<!--           <pest-real-data ref="pestRealData" v-if="indexType == 4 ? true : false"/>-->
           <pest-analyse-data ref="pestAnalyseData" v-if="indexType == 5 ? true : false"/>
           <pest-area-data ref="pestAreaData" v-if="indexType == 6 ? true : false"/>

           <spore-real-data ref="sporeRealData" v-if="indexType == 8 ? true : false"/>
           <spore-analyse-data ref="sporeAnalyseData" v-if="indexType == 9 ? true : false"/>

           <soil-real-data ref="soilRealData" v-if="indexType == 11 ? true : false"/>
           <soil-history-data ref="soilHistoryData" v-if="indexType == 12 ? true : false"/>

           <seed-data ref="seedData" v-if="indexType == 13 ? true : false"/>

           <mouse-analyse-data ref="mouseAnalyseData" v-if="indexType == 14 ? true : false"/>

           <target-analyse-data ref="targetAnalyseData" v-if="indexType == 16 ? true : false"/>

           <insec-real-data ref="inseRealData" v-if="indexType == 17 ? true : false"/>
           <insec-history-data ref="inseHistoryData" v-if="indexType == 19 ? true : false"/>
           <insec-control ref="inseControl" v-if="indexType == 18 ? true : false"/>
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
  import left from "./Left"
  import top from "./Top"
  import mainScreen from "./MainScreen"
  import meteRealData from "./MeteRealData"
  import meteHistoryData from "./MeteHistoryData"
  import pestRealData from "./PestRealData"
  import pestAnalyseData from "./PestAnalyseData"
  import pestAreaData from "./PestAreaData"
  import sporeRealData from "./SporeRealData"
  import sporeAnalyseData from "./SporeAnalyseData"
  import soilRealData from "./SoilRealData"
  import soilHistoryData from "./SoilHistoryData"
  import seedData from "./SeedData"
  import mouseAnalyseData from "./MouseAnalyseData"
  import targetAnalyseData from "./TargetAnalyseData";
  import insecRealData from './InsecRealData'
  import insecControl from './InsecControl'
  import insecHistoryData from './InsecHistoryData'
  import {userLogin} from "../../until/api/login";
  import {getAttributesServer} from "../../until/api/MeteSoil";
  import {insectUserLogin} from "../../until/api/inesctPest";
  export default {
    name: 'Home',
    components:{
      left,
      top,
      mainScreen,
      meteRealData,
      meteHistoryData,
      pestRealData,
      pestAnalyseData,
      pestAreaData,
      sporeRealData,
      sporeAnalyseData,
      soilRealData,
      soilHistoryData,
      seedData,
      mouseAnalyseData,
      targetAnalyseData,
      insecRealData,
      insecControl,
      insecHistoryData
    },

    data() {
      return {
        indexType: 0,
        spTokenTime: '',
        smTokenTime: '',
      }
    },

    mounted() {
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;

      if(authority != 'TENANT_ADMIN') {//非管理员用户
        this.getSPUserPwd(customerId);//获取虫情孢子账户用户名密码
      }

      this.getSMToken();
      // this.indexType = 1;
    },

    beforeDestroy() {
      //清空气象墒情时间
      clearInterval(this.spTokenTime);
      this.spTokenTime = null;
      //清空祥辰时间
      clearInterval(this.smTokenTime);
      this.smTokenTime = null;
      localStorage.clear();
    },

    methods: {
      /**
       * 获取气象墒情token
       */
      getSMToken() {
        //let paramJson =  JSON.parse(localStorage.getItem('login')); //获取气象墒情用户名密码
        //let paramJson =  JSON.parse(this.$commonFun.unCompileStr(localStorage.getItem('login'))); //获取气象墒情用户名密码

        //每隔2小时获取一次气象墒情的token
        this.spTokenTime = window.setInterval(() => {
          let paramJson = JSON.parse(this.$commonFun.unCompileStr(localStorage.getItem('login'))); //获取气象墒情用户名密码
          setTimeout(() => {
            userLogin(paramJson).then(response => {
              //localStorage.setItem('token', response.data.token);
              localStorage.setItem('token', this.$commonFun.compileStr(response.data.token));
            }).catch(error => {
              console.log("error", error)
            })
          }, 0)
        }, 1000 * 60 * 60 * 2);
      },

      getSPUserPwd(customerId) {
        let param = {"loginName": "", "loginPwd": ""};
        let pestParam = {"username": "", "password": ""};
        let nameFlg = false;
        let pwdFlg = false;
        let usernameFlg = false;
        let passwordFlg = false;
        getAttributesServer('CUSTOMER', customerId).then(response => {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].key.toString() == 'loginName') {
              param.loginName = response.data[i].value;
              nameFlg = true;
            } else if (response.data[i].key.toString() == 'loginPwd') {
              param.loginPwd = response.data[i].value;
              pwdFlg = true;
            } else if (response.data[i].key.toString() == 'username') {
              pestParam.username = response.data[i].value;
              usernameFlg = true;
            } else if (response.data[i].key.toString() == 'password') {
              pestParam.password = response.data[i].value;
              passwordFlg = true;
            }
          }
          if (nameFlg && pwdFlg) {//用户名密码全部获取
            this.sporePestLogin(JSON.stringify(param))//获取虫情孢子token
          }
          if (usernameFlg && passwordFlg) {
            this.insectLogin(JSON.stringify(pestParam));
          }

          if(!nameFlg && !pwdFlg && !usernameFlg && !passwordFlg &&  this.indexType == 0) {
            this.indexType = 1;
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      sporePestLogin(param) {
        let spLogin = JSON.parse(param);
        let that = this;

        this.$SporePestCommon.getSpToken(spLogin, function (token) {
          if(token == undefined) {
            if(that.indexType == 0) {
              that.indexType = 1;
            }
            return
          }
          localStorage.setItem('spToken', that.$commonFun.compileStr(token));
          if(that.indexType == 0) {
            that.indexType = 1;
          }
        })

        //每隔1.5小时获取一次虫情孢子token
        this.smTokenTime = window.setInterval(() => {
          setTimeout(() => {
            this.$SporePestCommon.getSpToken(spLogin, function (token) {
              //localStorage.setItem('spToken', token);
              localStorage.setItem('spToken', that.$commonFun.compileStr(token));
            })
          }, 0)
        }, 1000 * 60 * 60 * 1.5)
      },

      insectLogin(param) {
        let insectJson = JSON.parse(param);
        let username = insectJson.username;
        let password = insectJson.password;
        insectUserLogin(username, password).then(response => {
          if (response.data.code == 0) {
            for (let i = 0; i < response.data.data.length; i++) {
              if (response.data.data[i].name == 'Insects') {
                let token = response.data.data[i].token;
                localStorage.setItem('insectToken', this.$commonFun.compileStr(token));
              }
            }
            if(this.indexType == 0) {
              this.indexType = 1;
            }
          } else {
            if(this.indexType == 0) {
              this.indexType = 1;
            }
            console.log("用户名或者密码错误");
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       *获取祥辰设备token
       * @param param
       */
      // getXCLogin(param) {
      //   let that = this;
      //   //每隔12小时获取一次
      //   this.xcTokenTime = window.setInterval(() => {
      //     let xcLogin = JSON.parse(this.$commonFun.unCompileStr(localStorage.getItem('xcLogin')));
      //     setTimeout(() => {
      //       this.$SporePestCommon.getXCToken(xcLogin, function (token) {
      //         localStorage.setItem('spToken', that.$commonFun.compileStr(token));
      //       })
      //     }, 0)
      //   }, 1000 * 60 * 60 * 12)
      // },

      /**
       * 切换页面
       * @param index
       */
      getTypeIndex(index) {
        this.indexType = index;
      },

      getSoilMete(event, event1, event2, event3) {
        this.$refs.left.soilMeteShow(event, event1, event2, event3);
      },

      getSporeCount(event) {
        this.$refs.left.sporeShow(event);
      },

      getInsectCount(event) {
        this.$refs.left.insectShow(event);
      }
    }

  }
</script>

<style lang="less">
  @import "../less/Home";
</style>



// WEBPACK FOOTER //
// src/components/view/Home.vue